export default "__VITE_ASSET__3a8c5ebb__"